"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var ButtonDropdownLabel = function (props) {
    var _a = props.buttonLabel, buttonLabel = _a === void 0 ? '' : _a, _b = props.selectedValue, selectedValue = _b === void 0 ? '' : _b, _c = props.showSelectedValue, showSelectedValue = _c === void 0 ? false : _c, _d = props.hideButtonLabel, hideButtonLabel = _d === void 0 ? false : _d;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !hideButtonLabel && react_1.default.createElement("span", null, buttonLabel),
        showSelectedValue && (react_1.default.createElement(StyledSelected, { hideButtonLabel: hideButtonLabel }, selectedValue))));
};
exports.default = ButtonDropdownLabel;
var StyledSelected = styled_components_1.default(function (_a) {
    var hideButtonLabel = _a.hideButtonLabel, styledSelectedProps = tslib_1.__rest(_a, ["hideButtonLabel"]);
    return (react_1.default.createElement("span", tslib_1.__assign({}, styledSelectedProps)));
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-left: ", ";\n  text-transform: capitalize;\n  letter-spacing: normal;\n  font-family: ", ";\n"], ["\n  margin-left: ",
    ";\n  text-transform: capitalize;\n  letter-spacing: normal;\n  font-family: ", ";\n"])), function (_a) {
    var hideButtonLabel = _a.hideButtonLabel;
    return hideButtonLabel ? '0rem' : '0.8rem';
}, function (props) { return props.theme.fonts.robotoRegular; });
var templateObject_1;
